document.addEventListener('page:loaded', function() {

  // Build a class to handle the form (not only in modal, but we can place the form anywhere)
  class MembershipVerificationForm {
    constructor(form, options = null) {
      this.form = form;
      this.submitButton = form.querySelector('button[type=submit]');
      // Check if the form is inside a modal. And use built-in Modal class to create a modal
      this.modal = form.closest('#MembershipVerificationModal') ? new theme.Modals('MembershipVerificationModal', 'membership-verification-modal') : null;
      this.onSuccess = options?.onSuccess || (() => null);

      this.classes = {
        btnLoading: 'btn--loading',
        formError: 'form-error',
      }
      this.init();
    }

    init() {
      this.bindEvents();
    }

    async onSubmit(event) {
      event.preventDefault();

      const form = event.target;
      const FD = new FormData(form);

      const headers = new Headers();
      headers.append("Content-Type", "application/json");

      const bodyObj = Object.fromEntries(FD.entries());
      
      // As requested: "If a member leaves those two fields blank, it won't proceed to checkout but if they enter the incorrect information, it will still proceed to checkout."
      // But we checked that if the following information are wrong the validation API will return false, so we need to so send empty strings.
      bodyObj.majorKey = '';
      bodyObj.state = '';

      const body = JSON.stringify(bodyObj);

      const requestOptions = {
        method: 'POST',
        headers,
        body,
      };

      this.submitButton.classList.add(this.classes.btnLoading);

      await fetch("https://us-west1-silverponies.cloudfunctions.net/iaff-validate-membership", requestOptions)
        .then(response => response.json())
        .then(({result}) => {
          this.form.querySelector('.form-error.server-error').classList.add('hide');

          if (result) {
            // Remove errors if validated
            verificationForm.form.querySelectorAll('.info__copy').forEach(el => {
              el.classList.remove(this.classes.formError)
            });

            // Run onSuccess callback is validated
            if (typeof this.onSuccess === 'function') {
              this.onSuccess(result, this);
            }

            // Close modal if validated
            if (this.modal?.modalIsOpen) {
              this.modal.close();
            }
          }

          else {
            // Add errors if not validated
            this.form.querySelectorAll('.info__copy').forEach(el => {
              el.classList.add(this.classes.formError)
            });
          }

          return result;
        })
        .catch(error => {
          this.form.querySelector('.form-error.server-error').classList.remove('hide');
          console.log('error', error)
        });

      this.submitButton.classList.remove(this.classes.btnLoading);
    }

    bindEvents() {
      this.form.addEventListener('submit', this.onSubmit.bind(this));
    }
  }

  // Instantiate Form
  const membershipVerificationForm = document.getElementById('MembershipVerificationForm');
  let verificationForm = null;

  if (membershipVerificationForm) {
    verificationForm = new MembershipVerificationForm(document.getElementById('MembershipVerificationForm'));
    
    // Do some stuff when Modal is closed
    document.addEventListener('modalClose.MembershipVerificationModal', () => {
      // Clean up form when modal is closed
      verificationForm.form.querySelector('.form-error.server-error').classList.add('hide');
      verificationForm.form.querySelectorAll('.info__copy').forEach(el => {
        el.classList.remove('form-error')
      });
      verificationForm.form.reset();
    });
  }

  // ----------------------------START---------------------------------- //
  // Handle specific cases where the Modal was open by a checkout button //
  // ------------------------------------------------------------------- //

  // Grab all checkout buttons that open the MembershipVerificationModal (if there is more than one)
  const checkoutButtons = document.querySelectorAll('button[type=submit][name=checkout].js-modal-open-membership-verification-modal');

  if (checkoutButtons.length > 0) {
    // using named function in EventListeners should avoid duplicates
    const onVerificationSuccessGoToCheckout = () => {
      // Save previous onSuccess callback if any
      const previousOnSuccess = verificationForm.onSuccess;
  
      // If a checkout button was clicked BEFORE the modal was opened,
      // we add a onSuccess callback to redirect to /checkout
      verificationForm.onSuccess = () => {
        previousOnSuccess();
        window.location = '/checkout';
      };
  
      // Reset onSuccess callback to the previous state if the modal is closed
      document.addEventListener('modalClose.MembershipVerificationModal', () => verificationForm.onSuccess = previousOnSuccess);
    }
  
    for (const checkoutButton of checkoutButtons) {
      // Add listeners to the button
      checkoutButton.addEventListener('click', onVerificationSuccessGoToCheckout);
    }
  }
  // ----------------------------END------------------------------------ //
  // Handle specific cases where the Modal was open by a checkout button //
  // ------------------------------------------------------------------- //


  //------------------------//
  // START FREE GIFT SCRIPT //
  //------------------------//
  (function () {
    if (theme.iaff_free_gift.enabled) {
      const priceThreshold = theme.iaff_free_gift.threshold;
      const freeGiftVariantId = theme.iaff_free_gift.free_gift_product;
      
      const priceThresholdInCents = priceThreshold * 100;
      /**
       * Check cart content and add/remove free gift as needed
       */
      async function run() {
        const cart = await fetch(`${window.Shopify.routes.root}cart.js`, {
          method: 'GET',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
          }
        })
        .then((resp) => resp.json())
        .then((respData) => respData);
    
        const totalPrice = cart.total_price
    
        console.log(cart);
    
        const freeGiftVariantInCart = findFreeGiftVariantInCart(cart.items);
        const autoFreeGiftVariantInCart = findAutoFreeGiftVariantInCart(cart.items);
        if ((totalPrice >= priceThresholdInCents) && !autoFreeGiftVariantInCart && !freeGiftVariantInCart) {
          console.log('Adding free');
          await addFreeGiftToCart();
    
          setTimeout(() => {
            document.dispatchEvent(new CustomEvent('cart:build'))
          }
          , 500);
        }
    
        const isAutoFreeGift = !!autoFreeGiftVariantInCart;
        const shouldRemove = (totalPrice < priceThresholdInCents) && isAutoFreeGift;
        if (shouldRemove) {
          console.log('Removing free');
          await removeFreeGiftFromCart(autoFreeGiftVariantInCart.key);
        }
    
        const autoFreeGiftQuantity = autoFreeGiftVariantInCart?.quantity;
        const hasMoreThanOneAutoFreeGift = autoFreeGiftQuantity > 1;
        if (hasMoreThanOneAutoFreeGift) {
          console.log('Adjusting qtts');
          await addVariantToCart(autoFreeGiftQuantity - 1);
          await adjustFreeGiftQuantity(autoFreeGiftVariantInCart.key, 1);
    
          setTimeout(() => {
            document.dispatchEvent(new CustomEvent('cart:build'))
          }
          , 500);
        }
    
      }
    
      function findAutoFreeGiftVariantInCart(items) {
        return items.find((item) => {
          return (
            item.id === freeGiftVariantId &&
            item.properties._autoFreeGift === 'true'
          );
        });
      }
    
      function findFreeGiftVariantInCart(items) {
        return items.find(({id}) => id === freeGiftVariantId);
      }
    
      async function addFreeGiftToCart() {
        await addVariantToCart(1, true);
      }
    
      async function addVariantToCart(qtt, isAutoFreeGift = false) {
        const data = {
          items: [{
           id: freeGiftVariantId,
           quantity: qtt,
           properties: (isAutoFreeGift ? {
             _autoFreeGift: 'true'
           } : {})
          }],
        };
    
        console.log('data', data);
    
        return fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          body: JSON.stringify(data),
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
          }
        })
        .then(response => response.json())
        .then(function(resData) {
          if (!resData?.items) {
            // we might want to handle the error
            // or maybe not because it is a free gift
    
            return;
          }
    
          // Reload page if adding product from a section on the cart page
          if (document.body.classList.contains('template-cart')) {
            window.scrollTo(0, 0);
            location.reload();
          }
        }.bind(this));
      }
    
      async function removeFreeGiftFromCart(lineItemKey) {
        await adjustFreeGiftQuantity(lineItemKey, 0);
    
        setTimeout(() => {
          document.dispatchEvent(new CustomEvent('cart:build'))
        }
        , 500);
      }
    
      async function adjustFreeGiftQuantity(lineItemKey, qtt = 1) {
        const data = {
          id: lineItemKey,
          quantity: qtt,
        };
    
        return fetch(`${window.Shopify.routes.root}cart/change.js`, {
          method: 'POST',
          body: JSON.stringify(data),
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
          }
        });
      }
    
      document.addEventListener('cart:updated', run);
      document.addEventListener('ajaxProduct:added', run);
    
      run();
    }
  })();
  //------------------------//
  // END FREE GIFT SCRIPT //
  //------------------------//

});
